import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert, Fade } from 'react-bootstrap';

export const SuccessToolbar = ({ message = "✅ Action completed successfully!", delay = 4000 }) => {
  const [show, setShow] = useState(true);

  // Auto-dismiss after delay
  useEffect(() => {
    const timer = setTimeout(() => setShow(false), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <Fade in={show} unmountOnExit>
      <Alert
        variant="success"
        onClose={() => setShow(false)}
        dismissible
        className="text-center fixed-top mb-0 rounded-0"
        style={{ zIndex: 1050 }}
      >
        {message}
      </Alert>
    </Fade>
  );
};

SuccessToolbar.propTypes = {
  message: PropTypes.string,
  delay: PropTypes.number,
};

